import hoistNonReactStatics from 'hoist-non-react-statics';
import React, { ComponentType, forwardRef, useContext } from 'react';

import {
  PreferencesContext,
  PreferencesType,
  SetPreferencesType,
} from '@/app/providers/preferences-provider/PreferencesProvider';
import { $Subtract } from '@/shared/types/tile-packet.types';

export type PreferencesContextType = {
  setPreferences: SetPreferencesType;
  preferences: PreferencesType;
};

// react-redux doesn't work with forwardRef: https://github.com/reduxjs/react-redux/issues/914
// so this HOC always needs to wrap a connect call, and a connect call cannot wrap this.
export default function withPreferences<P extends PreferencesContextType>(
  Comp: ComponentType<P>,
): ComponentType<$Subtract<P, PreferencesContextType>> {
  const Result = forwardRef<unknown, $Subtract<P, PreferencesContextType>>(
    function PreferenceConsumerComponent(props, ref) {
      const ctx = useContext(PreferencesContext) as any;
      // @ts-ignore — generic forwarded props + ref
      return <Comp ref={ref} {...ctx} {...props} />;
    },
  );

  Result.displayName = `withPreferences(${Comp.displayName ?? Comp.name})`;
  hoistNonReactStatics(Result, Comp);
  return Result as any;
}
